import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'childGroupContact',
    label: 'Child Group Contact',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
